import { Injectable, OnDestroy } from '@angular/core';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { Subject } from 'rxjs';
import { ProcessingOverlayParam } from '../models/processing-overlay-param.model';
import { LoggingService } from './logging.service';

@Injectable()
export class OverlayManagerService implements OnDestroy {
    public showProcessingOverlay = new Subject<string | ProcessingOverlayParam>();
    public hideProcessingOverlay = new Subject<boolean>();
    public toggleBlurBackground = new Subject<boolean>();

    private _isBlurred = false;
    private _isProcessing = false;
    private _timer: any;

    constructor() {
        this.showProcessingOverlay
            .pipe(untilDestroyed(this))
            .subscribe((param: string | ProcessingOverlayParam) => {
                if (!param) return;

                clearTimeout(this._timer);

                const message: string = (typeof param === 'string') ? param : param.message;

                if (!message || message.trim() === '') return;

                LoggingService.log(`timeout: ${param['timeoutInSec']}`);

                if (param['timeoutInSec']) {
                    this._timer = setTimeout(() => {
                        this.hideProcessingOverlay.next();
                        param['timeoutCallback']();
                    }, (+param['timeoutInSec'] * 1000));
                }

                this.toggleBlurBackground.next(true);
                this._isProcessing = true;
            });

        this.hideProcessingOverlay
            .pipe(untilDestroyed(this))
            .subscribe((keepBackgroundBlurred = false) => {
                clearTimeout(this._timer);
                this._isProcessing = false;
                this.toggleBlurBackground.next(keepBackgroundBlurred);

            });

        this.toggleBlurBackground
            .pipe(untilDestroyed(this))
            .subscribe((isBlurred: boolean) => {
                this._isBlurred = isBlurred;
            });

    }

    ngOnDestroy() {
        /** Implemented to support untilDestroyed() **/
    }

    get isProcessing(): boolean {
        return this._isProcessing;
    }

    get isBlurred(): boolean {
        return this._isBlurred;
    }

}
